<template>
  <div class="maintenance-page">
    <h1>We'll be back soon!</h1>
    <p>We're currently performing scheduled maintenance.</p>
  </div>
</template>

<style scoped>
.maintenance-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
}
</style>
